const SheetIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M8.25 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.289 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75H11.4C12.6601 15.75 13.2902 15.75 13.7715 15.5048C14.1948 15.289 14.539 14.9448 14.7548 14.5215C15 14.0402 15 13.4101 15 12.15V9.75M9.75 12.75H5.25M11.25 9.75H5.25M15.091 2.90901C15.9697 3.78769 15.9697 5.21231 15.091 6.09099C14.2123 6.96967 12.7877 6.96967 11.909 6.09099C11.0303 5.21231 11.0303 3.78769 11.909 2.90901C12.7877 2.03033 14.2123 2.03033 15.091 2.90901Z"
        stroke="#091E42"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SheetIcon;
